/**
 * Generates unique ID that is used at the back-end to recognize what type of record it represents.
 * @param contact - string.
 */
export const generateUId = (contact: API_Contact) => {
    const type = contact.contactType ? 'contact' : 'user';
    return `@${type}${contact.id}`;
};